import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {Observable} from 'rxjs';
import {CategoryDtoModel} from '../models/category.dto.model';

@Injectable({
    providedIn: 'root'
})
export class CategoryService {

    private baseUrl = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/categories`;
    }

    public findAllCategories(): Observable<CategoryDtoModel[]> {
        return this.http.get<CategoryDtoModel[]>(`${this.baseUrl}`);
    }

    public updateCategory(category: CategoryDtoModel): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}`, category);
    }

    public createCategory(category: CategoryDtoModel): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}`, category);
    }

    public deleteCategory(uuid: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${uuid}`);
    }

    public updateListCategories(categoriesListToUpdate: CategoryDtoModel[]): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/list`, categoriesListToUpdate);
    }
}
